import React, {createContext, useEffect, useState} from "react";
import {Route, useParams} from "react-router-dom";
import {GetClientListResponse, IClientProto} from "../../../../../provider_api";
import {useRpcSender} from "../../../../../util/RpcSender";
import {RpcState} from "../../../../../util/RpcState";
import {ClientProfile} from "./ClientProfile";
import {Routes} from "react-router";
import {ClientTransactions} from "./ClientTransactions";
import {ClientBookings} from "./ClientBookings";

// All subpages of ClientView can access this context. This is done so they don't need to
// reload the client on every tab switch.
export type ClientContextType = {
  client: IClientProto | null | undefined;
  rpcState: RpcState;
};

export const ClientContext = createContext<ClientContextType>({client: null, rpcState: {state: 'none'}});

/**
 * The root of a single client view; this downloads the ClientProto for the user
 * which contains their User and ClientRelationship information. It does this
 * so child pages don't all need to duplicate the RPC logic.
 */
export const ClientView = () => {

  const {idParam} = useParams();
  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: "none"});

  const [client, setClient] = useState<IClientProto | null | undefined>();

  useEffect(() => {
    setRpcState({state: 'pending'});
    rpcSender.send('get_client_list', new Uint8Array([]))
        .then(r => {
          const response = GetClientListResponse.decode(r);
          if (!response.okay) {
            setRpcState({state: 'error', message: 'unknown error fetching login'});
            return;
          }

          // There should be only one response here.
          response.client.forEach(client => {
            if (client.user?.userId == idParam) {
              setClient(client);
            }
          })

          setRpcState({state: 'success'});

        })
        .catch(e => {
          setRpcState({state: 'error', message: e});
        })
  }, []);


  return <ClientContext.Provider value={{client: client, rpcState: rpcState}}>

    <Routes>
      <Route path={'/bookings'} element={<ClientBookings/>}/>
      <Route path={'/transactions'} element={<ClientTransactions/>}/>
      <Route path={'/'} element={<ClientProfile/>}/>
    </Routes>

  </ClientContext.Provider>;
}